import request from '@/utils/infrastructure/communication/request';

export async function queryChangePassword(data) {
  return request.post('/auth/changePassword', {
    data,
  });
}

export async function queryGetStProfileInfo() {
  return request(`/account/profileInfo`);
}

export async function queryChangeTwoFactor(status) {
  return request.post(`/account/changeTwoFactor/${status}`);
}
